import { toErrorMessage as i } from "../datadog.helper.js";
import { AUTHENTICATED_USER_STORAGE_KEY as s, CREDENTIAL_VALIDATION_ENDPOINTS as l } from "./expectedError.constants.js";
import { safeLocalStorage as d } from "../safeStorage/safeStorage.helper.js";
var u = (e) => {
  if (e == null || typeof e != "object") return;
  const t = e, o = t.response?.status;
  if (typeof o == "number")
    return {
      status: o,
      endpoint: typeof t.request?.endpoint == "string" ? t.request.endpoint : void 0,
      verb: typeof t.request?.verb == "string" ? t.request.verb : void 0
    };
}, a, A = (e) => {
  a = e;
}, c = () => {
  if (a) try {
    return a();
  } catch {
    return !1;
  }
  return d.getItem(s) != null;
}, p = (e) => e != null && l.some((t) => e.startsWith(t)), S = ({ error: e, isAuthenticated: t }) => {
  const o = t ?? c(), r = u(e), n = { authenticatedSession: o };
  return r && (n.httpStatus = r.status, r.endpoint && (n.endpoint = r.endpoint), r.verb && (n.verb = r.verb)), r?.status === 401 ? p(r.endpoint) ? {
    expected: !0,
    level: "info",
    reason: "invalid-credentials",
    context: {
      ...n,
      expectedError: "invalid-credentials"
    }
  } : o ? {
    expected: !1,
    level: "error",
    context: n
  } : {
    expected: !0,
    level: "info",
    reason: "anonymous-bootstrap",
    context: {
      ...n,
      expectedError: "anonymous-bootstrap"
    }
  } : i(e) === "No token available" && !o ? {
    expected: !0,
    level: "info",
    reason: "no-token-available",
    context: {
      ...n,
      expectedError: "no-token-available"
    }
  } : {
    expected: !1,
    level: "error",
    context: n
  };
};
export {
  S as classifyReportableError,
  c as hasPersistedUserId,
  u as readHttpErrorDetails,
  A as registerAuthenticatedSessionProbe
};

//# sourceMappingURL=expectedError.helper.js.map